import type { ReactNode } from "react"

export const PACKAGE_CARD_KEY = "allocation-planning.package-card"

export function CardTitle({ children, meta }: { children: ReactNode; meta?: ReactNode }) {
  return (
    <>
      <span className="header-h3 text-fg-base">{children}</span>
      {meta !== undefined && <span className="label-sm text-fg-muted">{meta}</span>}
    </>
  )
}
